<header class="background-header classic-background"></header>
<section class="main-side-nav"
    [ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}">
    <section class="container admin-dashboard-parent copy-editor-container">
        <section class="template-section-title">
            <div class="breadcrumb-container">
                <span>Admin <i class="fa fas fa-chevron-right"></i></span>
                <app-breadcrumb [pageName]="'Mail Queue'" [isTopLevel]="true"></app-breadcrumb>
            </div>
            <div class="title-container">
                <h1>Advisor Hub</h1>
            </div>
        </section>
        <div class="notification-bubble-container">
            <app-notification-bubble></app-notification-bubble>
        </div>
        <!-- Search -->
        <section class="all-users-line-presentation">
            <div class="search-section">
                <div class="accounts-number">
                    <span *ngIf="professionals">{{professionals.length}} Professionals</span>
                </div>
               <div class="buttons-managment">
                    <input type="text" class="dashboard-input" placeholder="Last Name" [(ngModel)]="searchData">
                    <input type="button" class="btn btn-primary search-btn" value="Search"
                        (click)="searchByLastName(searchData)">
                </div>
            </div>
        </section>
        <!-- Table of data sought-->
        <section class="data-sought-container">
            <section class="all-users-data">
                <div class="table-responsive admin-dashboard-table">
                    <table class="table table-hover table-borderless">
                        <thead>
                            <tr>
                                <th scope="col">First Name</th>
                                <th scope="col">Last Name</th>
                                <th scope="col">Email</th>
                                <th scope="col">Ref Code</th>
                                <th scope="col">Access Url Page</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let professional of usersFoundArray">
                                <tr>
                                    <td><span>{{professional.firstName}}</span></td>
                                    <td><span>{{professional.lastName}}</span></td>
                                    <td>{{professional.email}}</td>
                                    <td>{{professional.refCode}}</td>
                                    <td *ngIf="professional.client_access_page">
                                        <a href="{{professional.client_access_page}}" ngbTooltip="{{professional.client_access_page}}" placement="top">Link</a>
                                    </td>
                                </tr>
				 <tr class="body-body" [ngClass]="{'hide':selectedId!=professional.Id,'expanded':selectedId === professional.Id}">
                                     <td colspan="3">
                                         
                                         <label>
                                             <span class="label">Client Access Page Url</span>
                                             <input type="text" [(ngModel)]="clientAccessPageUrl">
                                         </label>
                                         <input type="submit" value="Save" (click)="saveItem(professional, clientAccessPageUrl)">
                                     </td>
                                 </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </section>
            <div *ngIf="usersFound == false">
                <div class="not-found-message">{{message}}</div>
            </div>
            <input *ngIf="dataIsLoaded" type="button" class="btn btn-primary back-table" value="Back"
                (click)="backToTable()">
        </section>

        <!-- Table of data not sought-->
        <section class="all-users-data" *ngIf="isSearching == false">
            <div class="table-responsive admin-dashboard-table">
                <table class="table table-hover table-borderless">
                    <thead>
                        <tr>
                            <th scope="col">First Name</th>
                            <th scope="col">Last Name</th>
                            <th scope="col">Email</th>
                            <th scope="col">Ref Code</th>
                            <th scope="col">Client Access Link</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let dataUser of professionals">
                            <tr (click)="toggleSection(dataUser.Id, dataUser.client_access_page)">
                                <td><span *ngIf="dataUser.firstName">{{dataUser.firstName}}</span></td>
                                <td><span *ngIf="dataUser.lastName">{{dataUser.lastName}}</span></td>
                                <td>{{dataUser.email}}</td>
                                <td>{{dataUser.refCode}}</td>
                                <td *ngIf="dataUser.client_access_page">
                                    <a href="{{dataUser.client_access_page}}"
                                        ngbTooltip="{{dataUser.client_access_page}}" placement="top">Link</a>
                                </td>
                            </tr>

                            <tr class="body-body"
                                [ngClass]="{'hide':selectedId!=dataUser.Id,'expanded':selectedId === dataUser.Id}">
                                <td colspan="3">
                                    <label>
                                        <span class="label">Client Access Page Url</span>
                                        <input type="text" [(ngModel)]="clientAccessPageUrl">
                                    </label>
                                    <input class="save-link" type="submit" value="Save"
                                        (click)="saveItem(dataUser, clientAccessPageUrl)">
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </section>
    </section>
    <app-pagination [currentPage]="currentPage" [totalPages]="totalPages"
        (pageChange)="loadPage($event)"></app-pagination>


</section>
